module.exports = __webpack_public_path__ + "static/img/1.05ef79f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/1.jpg
// module id = jY/k
// module chunks = 4